var _path, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUsdt(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 32C24.8366 32 32 24.8366 32 16C32 7.16344 24.8366 0 16 0C7.16344 0 0 7.16344 0 16C0 24.8366 7.16344 32 16 32Z",
    fill: "#50AF95"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_378_30375)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25.9094 14.2816C25.8072 14.1526 25.6996 14.0585 25.5894 13.9832C25.3715 13.8326 25.1591 13.7331 24.944 13.6497C24.5164 13.483 24.0915 13.3808 23.664 13.2894C22.8115 13.1146 21.9591 13.0312 21.1094 12.9532C20.2596 12.8699 19.4099 12.8349 18.5601 12.8027C18.3746 12.7946 18.189 12.7919 18.0008 12.7865V10.5869H23.8173V6.72266H8.32011V10.5869H14.1366V12.7838C13.9107 12.7892 13.6875 12.7946 13.4616 12.8053C12.6119 12.8403 11.7621 12.8726 10.9124 12.9559C10.0626 13.0366 9.2102 13.1173 8.35776 13.2948C7.93289 13.3835 7.50532 13.4857 7.07776 13.6551C6.86264 13.7385 6.6502 13.8353 6.43239 13.9885C6.32482 14.0638 6.21457 14.1579 6.11507 14.287C6.01558 14.4188 5.92684 14.6043 5.91608 14.8222C5.91339 15.04 5.99137 15.2336 6.08549 15.3761C6.17961 15.5159 6.28449 15.6208 6.38936 15.7095C6.59911 15.887 6.80885 16.008 7.0186 16.1156C7.4381 16.3334 7.86028 16.484 8.28516 16.6211C9.13222 16.8874 9.98465 17.089 10.8425 17.2343C11.7003 17.3714 12.5608 17.4816 13.424 17.5489C13.6633 17.565 13.9026 17.5758 14.1393 17.5865V25.53H18.0008V17.5811C18.1998 17.5704 18.4015 17.5623 18.6005 17.5489C19.4636 17.4897 20.3215 17.3714 21.182 17.2369C22.0398 17.0971 22.8922 16.89 23.7393 16.6238C24.1641 16.484 24.5836 16.3334 25.0058 16.1156C25.2156 16.008 25.4253 15.8843 25.6351 15.7069C25.7399 15.6181 25.8448 15.5106 25.9389 15.3707C26.0331 15.2282 26.111 15.0319 26.1084 14.8141C26.0976 14.599 26.0089 14.4134 25.9094 14.2816ZM25.3016 15.282C25.1403 15.4057 24.9547 15.5052 24.7665 15.5885C24.3873 15.7606 23.9813 15.8816 23.5725 15.9892C22.7551 16.199 21.9188 16.3388 21.0798 16.4464C19.3991 16.6561 17.705 16.7341 16.0109 16.7341C14.3168 16.7341 12.6226 16.6561 10.942 16.4464C10.103 16.3388 9.26667 16.2016 8.44919 15.9892C8.04314 15.8816 7.63709 15.7606 7.25524 15.5885C7.06432 15.5052 6.87877 15.4057 6.72011 15.282C6.55877 15.161 6.42431 14.9969 6.41625 14.8168C6.42163 14.6366 6.55608 14.4699 6.71743 14.3489C6.87877 14.2225 7.06163 14.123 7.25255 14.0396C7.63171 13.8648 8.03776 13.7411 8.44381 13.6309C9.26129 13.4158 10.0976 13.2732 10.9366 13.163C11.9988 13.0258 13.0663 12.9452 14.1339 12.8995V16.4275C14.7578 16.4517 15.3816 16.4652 16.0055 16.4652C16.6697 16.4652 17.3312 16.449 17.9954 16.4222V12.9048C19.0253 12.9506 20.0552 13.0312 21.0771 13.163C21.9161 13.2732 22.7524 13.4158 23.5699 13.6309C23.9759 13.7411 24.382 13.8648 24.7611 14.0396C24.952 14.1257 25.1376 14.2252 25.2962 14.3489C25.4576 14.4699 25.592 14.6366 25.5974 14.8168C25.5974 14.9969 25.463 15.161 25.3016 15.282Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_378_30375",
    x: 1.91602,
    y: 2.72266,
    width: 28.1924,
    height: 26.8074,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_378_30375"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_378_30375",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUsdt);
export default __webpack_public_path__ + "static/media/usdt.3f36690b9a972d9be6044d48dab9b290.svg";
export { ForwardRef as ReactComponent };